export default __webpack_public_path__ + "static/media/notification_archived.bba3aae3.svg";